import { ErrorMessage } from '@hookform/error-message';

import { FieldErrors } from 'react-hook-form';

import { FormItem } from '@ingrid/luterkort-react';

interface Props {
  errors: FieldErrors;
  name: string;
}

export function ValidationError({ name, errors }: Props) {
  return (
    <ErrorMessage
      render={({ message }) => <FormItem.ErrorText>{message}</FormItem.ErrorText>}
      errors={errors}
      name={name}
    />
  );
}
